import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../lib/api';

function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double execution in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      try {
        const hash = window.location.hash;
        const params = new URLSearchParams(hash.substring(1));
        const sessionId = params.get('session_id');

        if (!sessionId) {
          navigate('/login');
          return;
        }

        // Exchange session_id for user data
        const response = await api.post('/auth/session', { session_id: sessionId });

        // Store token in localStorage (primary auth method - cookies get stripped by proxies)
        if (response.data.session_token) {
          localStorage.setItem('session_token', response.data.session_token);
        }

        // Navigate to dashboard with user data
        navigate('/', { state: { user: response.data.user }, replace: true });
      } catch (error) {
        console.error('Auth callback error:', error);
        if (error.response?.status === 403) {
          alert('Access denied: Only vaaree.com domain emails are allowed');
        }
        navigate('/login');
      }
    };

    processSession();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-stone-50">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
        <p className="text-stone-600">Authenticating...</p>
      </div>
    </div>
  );
}

export default AuthCallback;
